module.exports = __webpack_public_path__ + "static/img/preview.ddb91a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/ninjatown-ninja-builder/preview.png
// module id = 104
// module chunks = 2